import { useCallback, useEffect, useState } from 'react';

export function useOtpCooldown() {
  const [deadline, setDeadline] = useState<number | null>(null);
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (!deadline) return;
    const update = () => {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setRemainingSeconds(remaining);
      if (remaining === 0) setDeadline(null);
    };
    update();
    const timer = window.setInterval(update, 1000);
    window.addEventListener('focus', update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', update);
    };
  }, [deadline]);

  const start = useCallback((seconds: number) => {
    const duration = Math.max(0, seconds);
    setDeadline(Date.now() + duration * 1000);
    setRemainingSeconds(duration);
  }, []);

  const reset = useCallback(() => {
    setDeadline(null);
    setRemainingSeconds(0);
  }, []);

  return { remainingSeconds, canResend: remainingSeconds === 0, start, reset };
}
